import { computed, state } from 'ccstate'
import { apiClient$ } from '../infra/apiClient'
import { instances } from '../../common/ccstatex/instances'

export const wordDetailDirty$ = state(1)

export const wordDetailInstances = instances(({ word }: { word: string }) => ({
  wordDetail$: computed(async (get) => {
    get(wordDetailDirty$)
    const apiClient = get(apiClient$)
    const result = await apiClient.getApi('getWordDetail', { word })

    // Add to history automatically when word detail is fetched
    if (result.word) {
      void apiClient.postApi('addSearchHistory', {
        wordId: result.word.id,
        word: result.word.word,
        briefMeaning: result.word.definitions[0]?.meaning || ''
      })
    }

    return result.word
  }),

  isFavorite$: computed(async (get) => {
    get(wordDetailDirty$)

    if (!word) {
      return false
    }

    const apiClient = get(apiClient$)
    const result = await apiClient.getApi('isFavorite', { wordId: word.toLowerCase() })
    return result.isFavorite
  })
}))
